<template>
  <el-card
    class="wrapper"
    :body-style="{ width: '100%', boxSizing: 'border-box', padding: '0 5px' }"
  >
    <div>
      <div class="panel-header">
        <div>Sources:</div>
        <div>
          <el-button
            class="style-button button-color-yellow"
            @click="openModalUplooad"
            >Upload media</el-button
          >
          <el-button
            class="style-button button-color-yellow"
            @click="openModalClick"
            >Select media</el-button
          >
        </div>
        <!-- <el-button class="style-button button-color-green"
          >Save edits</el-button
        > -->
      </div>
      <el-col
        v-loading="checkMangomoloUpload"
        :class="{ colSource: checkMangomoloUpload }"
        :xl="{ span: 10, offset: 0 }"
        :lg="{ span: 10, offset: 0 }"
        :md="{ span: 10, offset: 0 }"
        :sm="{ span: 10, offset: 0 }"
        :xs="{ span: 24, offset: 0 }"
      >
        <template v-for="item in itemsCheck">
          <el-col
            :key="item.id"
            class="wrapperItems"
            :class="{ selected: selectedSourceVideoId == item.id }"
          >
            <!-- :class='{"selected": selectedId == item.id}' -->
            <sources-list
              :stream-display-name="streamDisplayName"
              :selected-source-video-id="selectedSourceVideoId"
              :video-info="item"
              :thumbs="thumbs"
              :thumbnail-link="thumbnailLink"
              :is-updating-thumbnail="isUpdatingThumbnail"
              :duration-clip="durationClip"
              :stream="stream"
              :selected-option="selectedOption"
              :is-editing="isEditing"
              :prosentage-drag-end-drop="prosentageDragEndDrop"
              :are-editing-params-valid="areEditingParamsValid"
              @selectedOptions="selectedOptionEvent"
              @edits="handleEditings"
              @renewThumbnail="regenThumbnail"
              @changeCutMode="changeCut"
              @videoSelected="handleVideoSelect"
            />
          </el-col>
        </template>
      </el-col>
    </div>
  </el-card>
</template>

<script>
import ThumbnailImage from "@/components/timeline/thumbnails/ThumbnailImage.vue";
import SourcesList from "@/components/media/editing/SourcesList.vue";
/** assets */
import fallbackImage from "@/assets/images/empty.jpg";
import { mapState, mapGetters } from "vuex";
import Autorenew from "vue-material-design-icons/Autorenew.vue";
import { getDurationTimeline } from "@/utils/time.js";

import EditToolsBar from "@/components/media/editing/EditToolsBar.vue";

export default {
  name: "SourcesPanel",
  components: { ThumbnailImage, Autorenew, EditToolsBar, SourcesList },

  props: {
    streamDisplayName: {
      type: String
    },
    selectVideoUploadingId: {
      type: Array,
      default: null
    },
    prosentageDragEndDrop: {
      type: Number,
      default: 0
    },
    selectedSourceVideoId: {
      type: Number
    },
    selectIdVideo: {
      type: Array,
      required: true
    },
    mediaItemsList: {
      type: Object
    },
    // video data
    videoInfo: {
      type: Object,
      required: true
    },
    thumbnailLink: {
      type: String,
      default: fallbackImage
    },
    /** is poster refreshing */
    isUpdatingThumbnail: {
      type: Boolean,
      default: false
    },
    durationClip: {
      type: Number,
      default: null
    },
    /** Wowza stream name */
    stream: {
      type: String,
      default: "No Stream"
    },
    selectedOption: {
      type: String,
      default: "audio"
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    areEditingParamsValid: {
      type: String
    }
  },
  data() {
    return {
      /** fallback poster */
      sourcesItemsList: [],
      fallbackImage,
      firstCreatedId: this.videoInfo?.id || 0,
      playPreview: false,
      choceVideoId: [],
      selectedVideoId: 0,
      videoUploadId: this.selectVideoUploadingId
    };
  },
  watch: {
    selectVideoUploadingId() {
      if (this.selectVideoUploadingId && this.selectVideoUploadingId.length > 0) {
        this.selectIdVideo.push(this.selectVideoUploadingId[0]);
      }
    },
    selectIdVideo: {
      immediate: true,
      handler(newSelectIdVideo) {
        // Update choceVideoId with all IDs from selectIdVideo
        if (Array.isArray(newSelectIdVideo) && newSelectIdVideo.length > 0) {
          this.choceVideoId = [...newSelectIdVideo];
        } else {
          this.choceVideoId = [];
        }
      }
    },
    videoInfo: {
      immediate: true,
      handler(newVideoInfo) {
        if (newVideoInfo?.id && !this.firstCreatedId) {
          this.firstCreatedId = newVideoInfo.id;
        }
      }
    }
  },
  methods: {
    showLoading(message) {
      this.loadingInstance = this.$loading({
        lock: true,
        text: message,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 1)"
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    handleVideoSelect(id) {
      this.$emit("videoSelected", id);
      this.selectedVideoId = id;
    },
    changeCut() {
      this.$emit("changeCutMode");
    },
    openModalClick() {
      this.$emit("openModalSelect");
    },
    selectedOptionEvent(e) {
      this.$emit("selectedOption", e);
    },
    handleEditings(e) {
      this.$emit("edit", e);
    },
    openModalUplooad() {
      this.$emit("openModalUpload");
    },
    regenThumbnail() {
      this.$emit("renewThumbnail");
    }
  },
  computed: {
    selectVideoIdInModal() {
      return this.selectIdVideo;
    },
    ...mapGetters(["hasSudioMode", "channelType"]),
    ...mapState({
      thumbs: state => state.services.thumbs,
      timezone: state => state.timezone.timezone
    }),
    selectVideoId() {
      return this.videoInfo.id;
    },
    itemsCheck() {
      return this.audioItemsListSorted.length
        ? this.audioItemsListSorted
        : this.mediaItemsListSorted;
    },
    checkMangomoloUpload() {
      const hasMmVideoId = this.$route.query.mm_video_id != undefined;
      const hasMmAudioId = this.$route.query.mm_audio_id != undefined;
      return (
        this.mediaItemsListSorted.length == 0 &&
        (hasMmVideoId || hasMmAudioId)
      );
    },
    audioItemsListSorted() {
      // Convert IDs to numbers for consistent comparison
      const firstId = Number(this.firstCreatedId);
      const choiceIds = this.choceVideoId.map(id => Number(id));
      
      const sorted = this.mediaItemsList.audios.filter(
        e => {
          const videoId = Number(e.id);
          return videoId === firstId || choiceIds.includes(videoId);
        }
      );
      return sorted;
    },
    mediaItemsListSorted() {
      // Convert IDs to numbers for consistent comparison
      const firstId = Number(this.firstCreatedId);
      const choiceIds = this.choceVideoId.map(id => Number(id));
      
      const sorted = this.mediaItemsList.clips.filter(
        e => {
          const videoId = Number(e.id);
          return videoId === firstId || choiceIds.includes(videoId);
        }
      );
      return sorted;
    },

    // @vuese
    // Preview video source URL
    previewLink() {
      return this.videoInfo.previewLink
        ? `${this.thumbs}/${this.videoInfo.previewLink}`
        : this.thumbnailLink;
    },
    // @vuese
    // Duration time in format HH:mm:ss
    durationLine() {
      return getDurationTimeline(this.durationClip);
    }
  }
};
</script>
<style>
.el-loading-mask {
  background: #303133;
}
</style>

<style scoped>
.wrapper {
  margin: 0 0 15px 0;
  width: 100%;
  background: #aaaaaa;
  box-sizing: border-box;
}

.colSource {
  min-height: 150px;
}

.wrapperItems.selected > div {
  background: #6c6c6c;
  /* border-radius: 11px; */
  /* margin: 8px; */
}

/** thumbs */
.videoThumbContainer {
  position: relative;
  width: 240px;
}

.videoInfoLabel {
  width: 5rem;
  margin-right: 5px;
  display: inline-block;
  color: #ffffff;
}

.videoThumbOverlay {
  position: absolute;
  z-index: var(--video-thumb-overlay-z);
  right: 0;
  top: 0;
  user-select: none;
  cursor: pointer;
}
.videoThumbOverlay__icon {
  margin-right: 4px;
  margin-top: 4px;
}
.videoThumbOverlay__icon svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}

.videoInfoWrapper {
  display: flex;
}

.videoInfoStyleColumn {
  margin: 10px 0 0 30px;
}

.button-color-yellow {
  color: white;
  background: #6b645a;
  border: none;
  /* border-color: #947950; */
}
.button-color-yellow:hover {
  color: white;
  background: #e7c01f;
  /* border-color: #947950; */
  border: none;
}

.button-color-green {
  color: #ffffff;
  background-color: #67c23a;
  border-color: #67c23a;
}

.button-color-green:hover {
  background: #65ae41;
  border-color: #65ae41;
  color: #ffffff;
}

.margin-text {
  /* margin: 0 150px 0 0; */
  /* position: absolute; */
  /* font-family: sans-serif; */
  /* left: 10px; */
  /* top: 6px; */
}

.style-button {
  background: #ed5229;
  color: white;
  /* font-family: sans-serif; */
  padding: 0px 25px;
  font-size: 11px;
  border-radius: 4px;
  height: 30px;
  align-self: flex-end;
}

.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}

.panel-header {
  display: flex;
  align-items: baseline;
  padding: 10px;
  /* width: 100%; */
  justify-content: space-between;
  color: #000;
}

.videoInfoParam {
  justify-self: start;
  text-align: start;
  margin-bottom: 4px;
  font-size: 14px;
  display: flex;
  width: 100%;
}

@media only screen and (max-width: 639px), only screen and (max-height: 740px) {
  /*
  .style-button {
    font-family: sans-serif;
    font-size: 7px;
  }
  */

  /*
  .panel-header {
    justify-content: end;
  }
  */
}

@media only screen and (max-width: 767px) {
  .video-mangomolo-controls {
    justify-content: center;
  }
  /** video info */
  .videoInfoParam {
    margin-left: 15px;
    margin-top: 5px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
  }
  .videoInfoLabel {
    width: 8rem;
  }
}

@media only screen and (min-width: 768px) {
  .wrapper {
    margin: 0 0 15px 0;
    background: #aaaaaa;
  }

  .el-col-24 {
    width: 100%;
  }

  .wrapperItems.selected > div {
    background: #6c6c6c;
    box-shadow: inset 0 0 0 2px #111;
    /* border-radius: 11px; */
    /* margin: 15px 40px; */
  }
  /** video info */
  .videoInfoParam {
    font-size: 16px;
  }
  .videoInfoLabel {
    width: 4rem;
  }
}

@media only screen and (min-width: 992px) {
  .wrapper {
    margin: 0 0 15px 0;
    width: 100%;
    background: #aaaaaa;
  }
  .wrapperItems.selected > div {
    background: #6c6c6c;
    /* border-radius: 11px; */
    /* margin: 20px; */
  }
  /** Video thumbnail */
  .videoThumb {
    max-height: 160px;
    object-fit: contain;
  }
  /** video info */
  .videoInfoParam {
    font-size: 11px;
  }
  .videoInfoLabel {
    width: 4rem;
  }
}

@media only screen and (min-width: 1200px) {
  .wrapper {
    margin: 0 0 15px 0;
    background: #aaaaaa;
  }
  .wrapperItems {
    width: 100%;
  }
  /** video info */
  .videoInfoParam {
    font-size: 13px;
  }
  .videoInfoLabel {
    width: 57px;
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}

@media only screen and (min-width: 1920px) {
  .wrapper {
    margin: 0 0 15px 0;
    background: #aaaaaa;
  }
  .wrapperItems {
    /* width: 820px; */
  }
  /** video info */
  .videoInfoParam {
    font-size: 14px;
  }
  .videoInfoLabel {
    width: 6rem;
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
</style>
